import Vue from 'vue';
import Vuex from 'vuex';
import user from './user';
import configuration from './configuration';
import language from './language';
import fingerprint from './fingerprint'

Vue.use(Vuex);

export default new Vuex.Store({
    state: {},
    actions: {
        setInit(store) {
            // 初始化配置
            store.dispatch('configuration/setConfiguration');
            // 初始化user
            store.dispatch('user/setUser');
            // 初始化语言
            store.dispatch('language/setLanguage');
            // 初始化fp
            store.dispatch('fingerprint/setFP')
        },
        async saveUserVisited(store, to) {
            const cc = new Image();
            cc.style.display = 'none'
            const user = store.getters['user/getUser']
            const state = store.state as any;
            cc.src = `${store.getters['configuration/tongjiUrl']}/api/visited?hostname=${location.hostname}&path=${to.path}&fullPath=${to.fullPath}&userId=${user ? user.id : ""}&ssoId=${user ? user.userId : ""}&fp=${state.fingerprint.fp}`;
            document.querySelectorAll('body')[0].appendChild(cc);
        },
    },
    modules: {
        user,
        configuration,
        language,
        fingerprint
    },
});
